import { useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../../../hooks/redux'
import { setUpdate } from '../../../../store/reducers/app/LanguageSlice'
import { setSystemData } from '../../../../hooks/systemData'
import { ISwitch } from '../../../../models/ISwitch'
import { Strings } from '../../../../constants/Strings'
import { Colors } from '../../../../constants/Colors'
import style from './Language.module.css'
import Switches from '../../../widgets/Switches/Switches'

const Language = () => {

    const dispatch = useAppDispatch()

    const theme = useAppSelector<string>(state => state.theme.theme)
    const language = useAppSelector<string>(state => state.language.language)

    const languages = [
        {id: 1, title: 'tm', value: 'tm'},
        {id: 2, title: 'ru', value: 'ru'},
        {id: 3, title: 'en', value: 'en'},
        {id: 4, title: 'tr', value: 'tr'}
    ]

    const langIndex = languages.find(({value}) => value === language)

    const [selectedLanguage, setSelectedLanguage] = useState<ISwitch>(
        langIndex ? langIndex : {id: 1, title: 'tm', value: 'tm'}
    )

    useEffect(() => {
        if (selectedLanguage.value !== (langIndex ? langIndex.value : 'tm')) {
            setSystemData('language', selectedLanguage.value)
            dispatch(setUpdate(true))
        }
    }, [selectedLanguage])

    return (
        <div
            className={style.container}
        >
            <span
                className={style.icon}
                style={{
                    color: Colors[theme ?? 'light'].text
                }}
            >
                <i className="fas fa-globe"></i>
            </span>
            <span
                className={style.title}
                style={{
                    color: Colors[theme ?? 'light'].text
                }}
            >
                {Strings[language ?? 'tm'].lang}:
            </span>
            <div
                className={style.switchContainer}
            >
                <Switches
                    containerWidth={280}
                    containerHeight={40}
                    activeTextColor={Colors[theme ?? 'light'].white}
                    inActiveTextColor={Colors[theme ?? 'light'].text}
                    borderColor={Colors[theme ?? 'light'].app}
                    buttonBackgroundColor={Colors[theme ?? 'light'].secondBackground}
                    switchBackgroundColor={Colors[theme ?? 'light'].app}
                    switches={languages}
                    selectedSwitch={selectedLanguage}
                    setSelectedSwitch={setSelectedLanguage}
                />
            </div>
        </div>
    )
}

export default Language